// src/services/topUpPrefill.ts
// ----------------------------
// Pure rules for staff-prepared top-ups (stock_top_up_prefill, db-163).

// Before a service submits a staff-prepared top-up, its review page re-reads the prefill's
// status (getPrefillStatus). Staff may have CANCELLED it while the page was open — the
// submit RPC would otherwise still create the top-up (it only skips marking a non-pending
// prefill consumed). Returns the message to show, or "" to let the submit go ahead.
//   "pending"   → ok
//   "cancelled" → withdrawn by Zephyr
//   "consumed"  → already submitted
//   null        → can't be seen any more → treat as withdrawn
//   undefined   → the lookup failed (network) → don't block; the submit itself is the check
export function prefillSubmitBlock(status: string | null | undefined): string {
  if (status === undefined || status === "pending") return "";
  if (status === "consumed") {
    return "This prepared top-up has already been submitted. Please go back to My Requests.";
  }
  return "This prepared top-up was withdrawn by Zephyr, so it can't be submitted. Please go back to My Requests, or contact Zephyr if you still need stock.";
}
